import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import VisitScreen from '../screens/VisitScreen';
import PantriesScreen from '../screens/PantriesScreen';
import UpdateScreen from '../screens/UpdateScreen';
import ProfileScreen from '../screens/ProfileScreen';
import Plentiful from '../constants/Plentiful';

const Stack = createStackNavigator();
const INITIAL_ROUTE_NAME = 'pantries';

export default function TopMenuNavigator({ navigation, route }) {
  return (
    <Stack.Navigator
      initialRouteName={INITIAL_ROUTE_NAME}
      screenOptions={{
        title: Plentiful.TITLE,
        headerShown: false,
      }}
    >
      <Stack.Screen name="pantries">{(props) => <PantriesScreen {...props} />}</Stack.Screen>
      <Stack.Screen name="visits">{(props) => <VisitScreen {...props} />}</Stack.Screen>
      <Stack.Screen name="updates">{(props) => <UpdateScreen {...props} />}</Stack.Screen>
      <Stack.Screen name="profile">{(props) => <ProfileScreen {...props} />}</Stack.Screen>
    </Stack.Navigator>
  );
}
